/*@flow*/
import isNil from './isNil';
import assert from './assert';
import hasOwn from './hasOwn';

// safe mixin, cannot override props unless specified
export default function mixin(
  target: any,
  source: null | void | {},
  overwrite: boolean = false
): any {
  if (isNil(source)) {
    return target;
  }
  Object.keys(source).forEach(k => {
    if (overwrite !== true) {
      if (process.env.NODE_ENV !== 'production') {
        assert(
          !hasOwn.call(target, k) || target[k] === source[k],
          () =>
            'Invalid call to mixin(target, source, [overwrite]): cannot overwrite property "' +
            k +
            '" of target object'
        );
      }
    }
    target[k] = source[k];
  });
  return target;
}
